export default "__VITE_ASSET__BPbZlx3m__"